/* eslint-disable no-nested-ternary */
import { TabSetStyled, TabStyled } from '@nike/nike-design-system-components';
import React from 'react';
import { useDispatch } from 'react-redux';

import { invitationsActions } from './invitations/actions';
import { usersActions } from './users/actions';

import { TranslatedCopy } from '../intl/TranslatedCopy';

const UsersInvitationsTabs = () => {
  const dispatch = useDispatch();

  return (
    <TabSetStyled
      activeTab='users'
      onSelect={activeTab => {
        dispatch({
          type:
            activeTab === 'users'
              ? usersActions.selectUsers.name
              : activeTab === 'deactivated'
              ? usersActions.selectDeactivated.name
              : invitationsActions.selectInvitations.name
        });
      }}
    >
      <TabStyled id='users' key='users'>
        <title>
          <TranslatedCopy id='userManagement.tab.users' />
        </title>
      </TabStyled>
      <TabStyled id='deactivated' key='deactivated'>
        <title>
          <TranslatedCopy id='userManagement.tab.deactivated' />
        </title>
      </TabStyled>
      <TabStyled id='invitations' key='invitations'>
        <title>
          <TranslatedCopy id='userManagement.tab.invitations' />
        </title>
      </TabStyled>
    </TabSetStyled>
  );
};

export default UsersInvitationsTabs;
